import { createAction } from '@reduxjs/toolkit';

import { IError, IPatient } from '../../interfaces';
import { IPatientsBpStatusFilter, IPatientsSort, IPatientsSyncStatusFilter } from './types';

export const resetPatients = createAction('patients.reset-patients');
export const updatePatientsSearchText = createAction<{ searchText: string }>('patients.update-patients-search-text');
export const updatePatientsBpStatusFilter = createAction<{ filters: IPatientsBpStatusFilter }>(
  'patients.update-patients-bp-status-filter',
);
export const updatePatientsSyncStatusFilter = createAction<{ filters: IPatientsSyncStatusFilter }>(
  'patients.update-patients-sync-status-filter',
);
export const updatePatientsNewUserFilter = createAction<{ newUser: boolean }>(
  'patients.update-patients-new-user-filter',
);
export const updatePatientsSort = createAction<{ sort: IPatientsSort }>('patients.update-patients-sort');

export const fetchPatients = createAction('patients.fetch-patients');
export const fetchPatientsSucceeded = createAction<{ patients: IPatient[] }>('patients.fetch-patients.succeeded');
export const fetchPatientsFailed = createAction<IError>('patients.fetch-patients.failed');
